
const durum = [
    { key: 1, text: '1', value: 1 },
    { key: 2, text: '2', value: 2 },
    { key: 3, text: '3', value: 3 },
    { key: 4, text: '4', value: 4 },
    { key: 5, text: '5', value: 5 },
];
const duzeltDSTAv = [
    {1: [
        { key: 1, text: 'Günlük araç kontrolleri yaparken ayrıntılara dikkat etmeli,güvenli sürüşünüzü riske atmamalısınız', value: 1 },
        { key: 2, text: 'Günlük araç kontrolü sırasında elektriksel aksam kontrollerinin sağlıklı bir şekilde yaptığınızdan emin olmalısınız', value: 2 },
        { key: 3, text: 'Günlük araç kontrolleri sırasında emniyet kemeri kilitleme mekanizma kontrolünü,acil durumlarda yaratabileceği riski dikkate alarak yapmalısınız', value: 3 },
        { key: 4, text: 'Günlük araç kontrol sırasında doğru oturma pozisyonunu dikkate alarak koltuk ayarınızı doğru pozisyonda ayarlamalısınız.', value: 4 },
        { key: 5, text: 'Günlük araç kontrolleri sırasında YSClerinizi mutlaka kontrol etmeli , olası tehlikeler karşısında risk almamalısınız.', value: 5 },
        { key: 6, text: 'Günlük araç kontrolleri sırasında bir önceki gün formunu inceleyerek varsa eksikleri gidermeli , araç kabin içerisindeki hareketli cisimleri sabitlemelisiniz', value: 6 },

    ],
    2: [
        { key: 1, text: 'Araç hakimiyetinizi ,vites değişim aralığını dikkate alarak gaz pedalini ani reaksiyonla basmamalısınız.', value: 1 },
        { key: 2, text: 'Debriyaj kullanımında baskı - balata kavrama alanını dikkate alarak ayağınızı daha hassas kaldırmalısınız', value: 2 },
        { key: 3, text: 'Seyir halinde araç yükünü dikkate alarak fren pedaline daha hassas basmalısınız.', value: 3 },
        { key: 4, text: 'Bekleme sırasında debriyaj pedaline basılı viteste bekleme yapmamalısınız.', value: 4 },
        { key: 5, text: 'Vites değişim aralığında ara gazı kullanım alışkanlığınızı düzeltmelisiniz', value: 5 },
        { key: 6, text: 'İnişlerde ayağınızı sürekli fren pedali üzerinde tutmamalısınız', value: 6 },
        { key: 7, text: 'İnişlerde ayağınızı sürekli fren pedali üzerinde tutmamalısınız', value: 7 },
    ],
    3: [
        { key: 1, text: 'Gereksiz vites yükseltme ve düşürme alışkanlığınızı ,aracınıza verebileceğiniz amortisman giderini dikkate alarak düzeltmelisiniz.', value: 1 },
        { key: 2, text: 'Aracınızı doğru vites - doğru devir kullanmaya dikkat etmelisiniz', value: 2 },
        { key: 3, text: 'Vites değişimi sırasında vites başlığını fazla oynatmanız , vites geçişi sırasında seklambaçlara ciddi zaraz verebilir dikkat etmelisiniz.', value: 3 },
        { key: 4, text: 'Kasis geçişi sırasında aracınızın kasıntılara karşı zarar görmemesi için vites oynamamalısınız.', value: 4 },
        { key: 5, text: 'Vites küçültmek için aracınızın doğru devir olduğunda emin olmalı , devrinizi düşürmelisiniz.', value: 5 },
    ],
    4: [
        { key: 1, text: "Tek el direksiyon tutuş pozisyonunuzu 09:15'de olacak şekilde düzeltmelisiniz.", value: 1 },
        { key: 2, text: 'Dönüşlerde direksiyonu içten tutma alışkanlığınızı düzeltmeli , ani direksiyon dönmeleri karşısında oluşabilecek sakatlanmalarda kaçınmalısınız.', value: 2 },
        { key: 3, text: 'Baş parmaklarınızı direksiyon simidi üzerinde olacak şekilde tutuş pozisyonunuzu düzeltmelisiniz.', value: 3 },
        { key: 4, text: 'Manevra sırasında direksiyon simidini avuç içi tutmaya çalışarak tutuş pozisyonunuzu bozmamalısınız.', value: 4 },

    ],
    5: [
        { key: 1, text: 'Sollama öncesi sol ayna kontrölü yaparak arkadan gelen araç trafiğinin müsaitliğini kontrol etmelisiniz', value: 1 },
        { key: 2, text: 'Sollamalarda sinyal kullanım öncesi ayna kontrolü yaparak arkadan gelen araç trafiğinin müsaitlik durumunu konntol etmeli ,risk almamalısınız. ', value: 2 },
        { key: 3, text: 'Sollamalarda aracınızın her iki şeridi kullanış oluşundan dolayı ;  arka kör noktadan gelebilecek araçların yaratabileceği riskleri  dikkate almalısınız.', value: 3 },
        { key: 4, text: 'Düz çizgi geçiş noktalarında hatalı şerit değişmemeli , risk almamalısınız.', value: 4 },
        { key: 5, text: 'Aksi işaret ve önlemleri dikkate almayarak ( levha )sollama yapmamalısınız.', value: 5 },
        { key: 6, text: 'Hareket yönünüze göre aracınızı kesik çizgi içerisinde doğru şeritte konumlamalısınız.', value: 6 },

    ],
    6: [
        { key: 1, text: 'Sürüş sırasındaki ağresif davranışınızı düzeltmeli , sakin olmalısınız.', value: 1 },
        { key: 2, text: 'Sürüş sırasındaki ruh haliniz,  tedirgin oluşunuz ciddi risk yaratabilir.', value: 2 },
        { key: 3, text: 'Seyir esnasında diğer sürücü hatalarını , trafik saygı kültürü içinde kaşılamalı sakin olmalı , sözlü sataşmaya kalkışmamalısınız.', value: 3 },

    ],
    7: [
        { key: 1, text: 'Seyir esnasında aracınızı orta şeride yakın konumlayarak iki yönlü yollarda karşıdan gelen araç trafiğine karşı risk almamalısınız.', value: 1 },
        { key: 2, text: 'Seyir esnasında sağ emniyet şeridi ihlali yapmamalı , beklenmedik durumlarda risk almamalısınız. ', value: 2 },

    ],
    8: [
        { key: 1, text: "3'ncü şahısların her an yola çıkabileceğini dikkate alarak aracını konumlamalı risk almamalısınız.", value: 1 },
        { key: 2, text: "3'ncü şahıslara yakın geçiş yapmamalı ,her an anayol üzerine çıkabileceğini hesaplamalısınız.", value: 2 },

    ],
    9: [
        { key: 1, text: 'Bekleme noktalarında öndeki araçla olan emniyetli takip mesafenizi korumalı , risk almamalısınız', value: 1 },
        { key: 2, text: 'Seyir halinde 2 sn.1453…1453 kuralını dikkate alarak takip mesafenizi korumalı ,acil durumlarda durma mesafenizi dikkate almalısınız.', value: 2 },
        { key: 3, text: 'Beklemelerde aracınızı sabitlemek için el freni kullanım alışkanlığı edinmeli ve geliştirtmelisiniz.', value: 3 },
    ],
    10: [
        { key: 1, text: 'Şerit değişim öncesi ayna kontrolü sonrası trafik müsaitse şerit değişmelisiniz', value: 1 },
        { key: 2, text: 'Sisli havalarda dörtlü flaşör kullanım alışkanlığınızı , sis lambası kullanımı olarak değiştirmeli ve geliştirmelisiniz.', value: 2 },
        { key: 3, text: 'iki yönlü yollarda sol şeritte sinyalinizi açık bırakarak arkadan ve karşıdan gelen araç trafiğinin farkındalığını artırmalısınız.', value: 3 },
        { key: 4, text: 'Bölünmüş yollarda sol şeritte sinyalinizi açık bırakarak arkadan  gelen araç trafiğinin farkındalığını artırmalısınız.', value: 4 },
        { key: 5, text: 'Otoyol 3 şerit sol kesiminde sollama sonrası orta şeritte sinyalinizi kapatmalı arkadan gelen trafiğin şerit değiştireceğiniz hissiyatını yaratmamalısınız.', value: 5 },
    ],
    11: [
        { key: 1, text: 'Genel ayna kontrollerinizi ve kör nokta aynalarınızı 5-8 sn sıklığında olacak şekilde artırmalısınız', value: 1 },
        { key: 2, text: 'İlk kalkışlarda ön peron aynası kontrol alışkanlığı edinmeli ve geliştirmelisiniz.', value: 2 },
        { key: 3, text: 'Sağ ayna kontrolerinizi sğadan gelebilecek tehlikeleri dikkate alarak artırmalısınız.', value: 3 },
        { key: 4, text: 'Tehlikeli bölge geçişi sırasında bölge geçişi tamamlanana kadar ayna kontrollerinizi yapmalısınız.', value: 4 },
    ],
    12: [
        { key: 1, text: 'Trafik işaret ve levha takip alışkanlığı edinmeli, olası riskleri önceden görerek kaçınmalısınız.', value: 1 },
        { key: 2, text: 'Trafik levha bilgilerinizi güncellemelisiniz.', value: 2 },
        { key: 3, text: 'Trafik levhalarına mutlaka uymalı olabilecek risklerden kaçınmalısınız.', value: 3 },
    ],
    13: [
        { key: 1, text: 'İleriyi kontrol ederek aracını kullanıyor oluşunuz başarılı bulunmuştur.', value: 1 },
        { key: 2, text: 'İleriyi kontrol ederek tehlikeleri fark etmeli, hareket bölgesinde aracınızı doğru konumlayarak risklerden kaçınmalısınız.', value: 2 },
        { key: 3, text: 'Görüş bölgesi içerisindeki  tehlikeleri fark ederek emniyetli mesfe bırakarak uzaklaşmalısınız.', value: 3 },
    ],
    14: [
        { key: 1, text: 'Kurallara bakışınızı pratik sürüşünüzede yansıtmalı, risk almamalısınız.', value: 1 },
    ],
    15: [
        { key: 1, text: 'Dönel kavşak içerisinde aracınızı doğru konumlamalısınız.', value: 1 },
        { key: 2, text: 'Dönel kavşak içerisinde aracınızı doğru şeritte konumlamalısınız.', value: 2 },
        { key: 3, text: 'Dönel kavşaklarda dorse boyunu dikkate alarak aracınızı konumlamalı  , doğru manevra yapmalısınız.', value: 3 },
        { key: 4, text: 'Dönel kavşak içerisinde bekleme sırasında şerit kesmemeli , kendi şeridinizde kalmalısınız.', value: 4 },
        { key: 5, text: 'Dönel kavşak içerisinde dönüş istikametinize göre şerit seçmelisiniz', value: 5 },
        { key: 6, text: 'Kavşak dönüşlerinde anayola katılım için aracınızı çapraz konumlayarak sağdan gelen araç trafiğinin kontrolünü riske atmamalısınız.', value: 6 },
        { key: 7, text: 'Dönel kavşak dönüşü sırasında sağ kör noktanızı dikkate alarak , aracınızı konumlamalı kör nokta riski almamalısınız.', value: 7 },
    ],
    16: [
        { key: 1, text: 'Kontrolsüz kavşak geçişlerinde kavşak içerisindeki araç hareketlerini dikkate alarak yaratabileceği risklerden kaçınmalısınız', value: 1 },

    ],
    17: [
        { key: 1, text: 'Geri manevra öncesi yan camlarınızı yarı açarak manevra yapmalı , arkadan gelebilecek uyarı (ses) duymalısınız.', value: 1 },
        { key: 2, text: "Geri manevra öncesi dörtlü flaşörünüzü açarak kör noktalardaki 3'ncü şahısları uyarmalısınız.Kör noktadaki şahısların sağlam ve sağlıklı olduğu garantisi yok.", value: 2 },
        { key: 3, text: 'Geri maevra öncesi yardımcıyı mutlaka arka sağ tarafınızda olacak şekilde uyarmalı ,kör nokta riski almamalısınız.', value: 3 },
        { key: 4, text: 'Geri manevra sırasında her iki yönü kontrol ederek manevra yapmalı, kör nokta riski almamalısınız.', value: 4 },
        { key: 5, text: 'Geri manevra park noktanızı dikkate alarak aracınızı ileri manevra sırasında doğru konumlamalı , çapraz konumdan kaçınmalı, manevra açınızı daraltmamalısınız.', value: 5 },

    ],
    18: [
        { key: 1, text: 'Yasal hız limit aşımı yaparak oluşabilecek acil durumlar karşısında risk almamalısınız.', value: 1 },
        { key: 2, text: 'Otoyol  yasal hız limit aşımı yapmamaya dikkat etmeli , risk almamalısınız.', value: 2 },
        { key: 3, text: 'Bölünmüş yol kesimlerinde yasal hız limit aşımı yaparak risk almamalısınız.', value: 3 },
        { key: 4, text: 'Meskün mahal geçişlerinde yasal hız limit aşımı yapmamaya dikkat etmeli , risk almamalısınız.', value: 4 },
        { key: 5, text: 'Uyarıcı yasal hız limit levhalarını dikkate alarak tehlikeli bölge geçişlerinde hız limitini düşürmelisiniz.', value: 5 },
    ],
    19: [
        { key: 1, text: 'Tehilkeli alanda kaçınmada geç kalmamalı risk almamalısınız', value: 1 },
        { key: 2, text: 'Tehlikeli alanlardan kaçınmada arkadan gelen araç trafiğini dikkate almalı risk almamalısınız.', value: 2 },
        { key: 3, text: 'Tehlikeli bölge geçişi sırasında bölgeden çıkana kadar sağ ayna kontrollerinizi sağlamalısınız.', value: 3 },
        { key: 4, text: 'Tehlikeli bölge geçişi sırasında acil durumlar karşısında oluşubilecek riskleri dikkate alarak hız limitinizi düşürmelisiniz.', value: 4 },

    ], 
    20: [
        { key: 1, text: 'Yayaların yaratabileceği riskleri dikkate alarak geçiş yapmalısınız.', value: 1 },
        { key: 2, text: "Bisiklet sürücülerinin sağ kör noktanızda yaratabileceği riskleri dikkate alarak, ayna kontrollerinizi sıklaştırmalı , hızınızı düşürmelisiniz.", value: 2 },
        { key: 3, text: "Motosiklet sürücülerin ani manevra yapabileceğini dikkate alarak yanlarında geçerken kontrollerinizi artırmalı , risk almamalısınız.", value: 3 },

    ],
    /* 2: [
        { key: 1, text: '', value: 1 },
        { key: 2, text: '', value: 2 },
        { key: 3, text: '', value: 3 },
        { key: 4, text: '', value: 4 },
        { key: 5, text: '', value: 5 },
        { key: 6, text: '', value: 6 },

    ], */

    }
];
const devamDSTAv = [
    {
        1: [
            { key: 1, text: 'Günlük araç kontrollerini güvenli sürüşünüzü dikkate alarak ayrıntılı şekilde yapışınızı devam ettiriniz.', value: 1 },
            { key: 2, text: 'Günlük araç kontrolleri sırasında elektriksel aksam kontrollerinizi geliştirerek devam ettiriniz.', value: 2 },
            { key: 3, text: 'Emniyet kemerinin önemi alğılayarak kontrol ettikten sonra kullanıyor oluşunuz başarılı bulunmuştur.', value: 3 },
            { key: 4, text: 'Doğru açı ve fiziksel rahatsızlık risklerini dikkate alarak koltuk oturma pozisyonunuzu ayarlayışınız başarılı bulunmuştur.', value: 4 },
            { key: 5, text: "Günlük araç kontrolleri sırasında YSC'leri dikkate alarak kontrollerinizi tamamlayışınız başarılı bulunmuştur.", value: 5 },
            { key: 6, text: 'Kabin içerisindeki hareketli cisimleri sabitleyişiniz başarılı bulunmuştur.', value: 6 },
        ],
        
        2: [
            { key: 1, text: 'Araç hakimiyetiniz , gaz hassasiyetiniz başarılı bulunmuştur', value: 1 },
            { key: 2, text: 'Debriyaj hassasiyetiniz , vites değişim aralığını doğru planlayışınız başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Araç yükünü dikkate alarak fren pedalindeki hassas reaksiyonunuz başarılı bulunmuştur.', value: 3 },
            { key: 4, text: 'Bekleme sırasında aracınızı vitesten alışınız başarılı bulunmuştur.', value: 4 },
            { key: 5, text: 'Vites değişim aralığında ara gazı kullanmayış oluşunuz başarılı bulunmuştur.', value: 5 },
            { key: 6, text: 'İnişlerde fren pedalini yer yer kullanarak balatalrı ısınmasını önleyiş mantığı ile aracınızı kullanışınız başarılı bulunmuştur.', value: 6 },
            { key: 7, text: 'Uygun olmayan hava ve yol şartlarında yardımcı durdurma ekipmanı kullanmıyor oluşunuz başarılı bulunmutur.', value: 7 },

        ],
        3: [
            { key: 1, text: 'Aracınızı gereksiz vites değişimlerinde kullanmayarak , kullanmanız başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'Aracınızı doğru vites doğru devir kullanış oluşunuz başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Vites değşimi sırasında orta boşlukta vitesle fazla oynamadan vites değişiminiz başarılı bulunmuştur.', value: 3 },
            { key: 4, text: 'Kasis geçişleri sırasında vitesle oynamayışınız başarılı bulunmuştur.', value: 4 },
            { key: 5, text: 'Vites küçültmelerde doğru düşük devirde aracınızı kullanıyor oluşunuz başarılı bulunmuştur.', value: 5 },

        ], 
        4: [
            { key: 1, text: 'Direksiyon tutuş pozisyonunuzu acil durumlarda doğru pozisyonda tutmak için bozmayış oluşunuz başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'Dönüşlerde direksiyonu doğru pozisyonda tutuş oluşunuz başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Baş parmaklarınız simit üzerinde olarak tutuş pozisyonunuzu bozmayışınız başarılı bulunmuştur.', value: 3 },
            { key: 4, text: 'Manevra sırasında direksiyon tutuş pozisyonunuzu bozmayışınız başarılı bulunmuştur.', value: 4 },

        ],
        5: [
            { key: 1, text: 'Sollama öncesi sol ayna kontrolü yaparak arkadan gelen araç trafiğini kontrol ediş oluşunuz başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'Sollamalarda ayna kontrolü sonrası sinyal kullanımınız başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Sollamalarda şeridinizi tam olarak kullanışınız, şerit düzenine uyuşunuz başarılı bulunmuştur.', value: 3 },
            { key: 4, text: 'Düz çizgi geçiş noktasında şerit değişmeyerek, kesik çizgi geçiş noktalarına  şerit değişiminiz başarılı bulunmuştur.', value: 4 },
            { key: 5, text: 'Aksi işaret ve önlemleri dikkate alarak müsait olduğu halde sollamaya çıkmayarak risk almayışınız başarılı bulunmuştur.', value: 5 },
            { key: 6, text: 'Gidiş istikametinize göre şerit seçiminiz başarılı bulunmuştur.', value: 6 },

        ],
        6: [
            { key: 1, text: 'Sürüş sırasındaki sakin tavrınız başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'Sürüş sırasındaki ruh haliniz, defansif yaklaşımınız başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Seyir esnasında diğer sürücü hatalarını saygı kültürü içerisinde kaşılayışınız başarılı bulunmuştur.', value: 3 },

        ],
        7: [
            { key: 1, text: 'Aracınızı şeridiniz içerisinde doğru pozisyonda konumlayarak seyriniz başarılı bulunmuştur', value: 1 },
        ],
        8: [
            { key: 1, text: '3ncü şahısların yanından geçerken yaratabileceği riski dikkate almanız ve aracınızı konumlamanız başarılı bulunmuştur.', value: 1 },
        ],
        9: [
            { key: 1, text: 'Bekleme noktalarında öndeki araçla olan takip mesafenizi koruyuş oluşunuz başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'Seyir halinde öndeki araçla olan takip mesafenizi 2 sn.kuralını dikkate alarak aracınızı kullanıyor oluşunuz başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Beklemelerde aracınızı sabitlemek için el freni kullanım alışkanlığınız başarılı bulunmuştur.', value: 3 },

        ],
        10: [
            { key: 1, text: 'Şerit değişim kurallarını dikkate alarak , risk almadan şerit değişiminiz başarılı bulunmuştur', value: 1 },
            { key: 2, text: 'Sisli  havalarda sis lambası kullanım alışkanlığınız , tehlikere karşı  önlem almanız başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'İki yönlü yollarda sollama esnasında sol şeritte sinyalinizi açık tutma alışkanlığınız başarılı bulunmuştur.', value: 3 },
            { key: 4, text: 'Bölünmüş  yollarda sollama esnasında sol şeritte sinyalinizi açık tutma alışkanlığınız başarılı bulunmuştur.', value: 4 },
            { key: 5, text: 'Otoyol 3 şerit yol kesiminde sollama sonrası orta şeritte sinyalinizi kapatma alışkanlığınız başarılı bulunmuştur.', value: 5 },

        ],
        11: [
            { key: 1, text: 'Genel ve kör nokta aynalarınızı oluşabilecek tehlike ve riskleri dikkate alarak 5-8 sn sıklığında yapıyor oluşunuz başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'Ön kör nokta risklerini dikkate alarak peron ayna kontrolü yapışınız başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Tehlikeli bölge geçişleri sırasında ayna kontrollerinizi yapıyor oluşunuz başarılı bulunmuştur', value: 3 },

        ],
        12: [
            { key: 1, text: 'Trafik işaret ve levhalarını takip ederek risklere karşı önlem alışınız başarılı bulunmutur.', value: 1 },
            { key: 2, text: 'Trafik levha bilgileriniz , ve takip alışkanlığınız başarılı bulunmuştur.', value: 2 },
        ],
        13: [
            { key: 1, text: 'İleriyi kontrol ederek aracınızı kullanıyor oluşunuz başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'İleriyi kontrol ederek tehlikeleri fark edişiniz ve hareket bölgesi içerisinde tehlikelerden kaçınmanız başarılı bulunmuştur.', value: 2 },

        ],
        14: [
            { key: 1, text: 'Kurallara bakışınız ve eğitim sırasında uygulayışınız başarılı bulunmuştur.', value: 1 },

        ],
        15: [
            { key: 1, text: 'Dönel kavşak içerisinde aracınızı doğru konumlayışınız başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'Dönel kavşak içerisinde aracınızı doğru şeritte konumlayışınız başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Dönel kavşaklarda dorse boyunu dikkate alarak aracınızı konumlamanız başarılı bulunmuştur.', value: 3 },
            { key: 4, text: 'Kavşak dönüşlerinde aracınızı 90 derece açıyla konumlayarak sağdan gelen araç trafiğini kontrol sonrası anayola katılımınız başarılı bulunmuştur.', value: 4 },
            { key: 5, text: 'Dönel kavşak dönüşlerinde kör nokta risklerini dikkate alarak aracınızı konumlamanız başarılı bulunmuştur.', value: 5 },
            { key: 6, text: 'Kontrolsüz kavşak geçişlerinde kavşak içerisinde araçların hareketlerini dikkate alarak aracınızı kullanışınız başarılı bulunmuştur.', value: 6 },

        ],
        16: [
            { key: 1, text: 'Geri manevra öncesi yan camlarınızı açarak arkadan gelebilecek uyarılara karşı tedbir alışınız başarılı bulunmuştur.', value: 1 },
            { key: 2, text: "Geri manevra öncesi 4'lü flaşörünüzü açarak 3'ncü şahısları uyarıyor oluşunuz başarılı bulunmuştur.", value: 2 },
            { key: 3, text: 'Geri manevra öncesi sağ kör nokta riskini dikkate alarak sağ yardım almış oluşunuz başarılı bulunmuştur.', value: 3 },
            { key: 4, text: 'Geri manevra sırasında her iki yönü kontrol ediş oluşunuz başarılı bulunmuştur.', value: 4 },
            { key: 5, text: 'Geri menevra öncesi ileri manevrada aracınızı doğru konumda tutarak geri manevra yapış oluşunuz baaşrılı bulunmuştur.', value: 5 },

        ],

        17: [
            { key: 1, text: 'Geri manevra öncesi yan camlarınızı açarak arkadan gelebilecek uyarılara karşı tedbir alışınız başarılı bulunmuştur.', value: 1 },
            { key: 2, text: "Geri manevra öncesi 4'lü flaşörünüzü açarak 3'ncü şahısları uyarıyor oluşunuz başarılı bulunmuştur.", value: 2 },
            { key: 3, text: 'Geri manevra öncesi sağ kör nokta riskini dikkate alarak sağ yardım almış oluşunuz başarılı bulunmuştur.', value: 3 },
            { key: 4, text: 'Geri manevra sırasında her iki yönü kontrol ediş oluşunuz başarılı bulunmuştur.', value: 4 },
            { key: 5, text: 'Geri menevra öncesi ileri manevrada aracınızı doğru konumda tutarak geri manevra yapış oluşunuz baaşrılı bulunmuştur.', value: 5 },
        ],

        18: [
            { key: 1, text: 'Acil durumlarda oluşabilecek tehlikeleri ve yasal zorunluluğu dikkate alarak hız limit kurallarına uyumunuz başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'Yasal hız limitlerine uyumunuz başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Uyarıcı yasal hız limit levhalarını takibiniz ve hızınızı limitler içerisinde hareket ediş oluşunuz başarılı bulunmuştur.', value: 3 },
        ],

        19: [
            { key: 1, text: 'Tehlikeli alandan kaçınmanız başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'Tehlikeli alanlardan kaçış sırasında arkadan gelen araç trafiğini dikkate alarak kaçınmanız başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Tehlikeli bölge geçişi sırasında sağ ayna kontrolü ile geçişinizi tamamlayışınız başarılı bulunmuştur.', value: 3 },
            { key: 4, text: 'Tehlikeli bölge geçişi sırasında acil durumlar karşısında oluşabilecek riskleri dikkate alarak hızınızı düşürüyor oluşunuz başarılı bulunmuştur.', value: 4 },
        ],

        20: [
            { key: 1, text: 'Yayaların yaratabileceği riskleri dikkate alarak aracınızı kullanıyor oluşunuz başarılı bulunmuştur.', value: 1 },
            { key: 2, text: 'Bisiklet sürücülerinin yaratabileceği riskleride dikkate alarak ayna kontrollerinizi artırıyor oluşunuz başarılı bulunmuştur.', value: 2 },
            { key: 3, text: 'Motosiklet sürücülerinin yaratabileceği riski dikkate alarak kontrollü geçiş sağlıyor oluşunuz başarılı bulunmuştur', value: 3 },


        ],
        
        /*
        4: [
            { key: 1, text: '', value: 1 },
            { key: 2, text: '', value: 2 },
            { key: 3, text: '', value: 3 },
            { key: 4, text: '', value: 4 },
            { key: 5, text: '', value: 5 },
            { key: 6, text: '', value: 6 },

        ],*/

    }
];

    
export const Araclar = [
    { text: 'Kisi', value: 'kisi' },
    { text: 'Kiralik', value: 'kiralik' },
    { text: 'Sirket', value: 'sirket' },
];
export const Trafik = [
    { text: 'Hafif', value: 'hafif' },
    { text: 'Orta', value: 'orta' },
    { text: 'Agir', value: 'agir' },
];
export const YolDurumu = [
    { text: 'Sehir Ici', value: 'sehirici' },
    { text: 'Sehirler Arasi', value: 'sehirlerarasi' },
    { text: 'Kirsal', value: 'kirsal' },
];
export const SurusSartlari = [
    { text: 'Gunduz', value: 'gunduz' },
    { text: 'Gece', value: 'gece' },
];
export const Hava = [
    { text: 'Kuru', value: 'kuru' },
    { text: 'Yagmur', value: 'yagmur' },
    { text: 'Kar', value: 'kar' },
];
export const Selections2 = [
    {
        key: 1,
        label: 'Arac Plaka',
        id: 'VehiclePlate',

    }, {
        key: 2,
        label: 'Arac Model',
        id: 'VehicleModel',
    }, 
    {
        key: 3,
        label: 'Arac Marka/Tipi',
        id: 'VehicleBrand',
    },
    {
        key: 4,
        label: 'Km',
        id: 'Distance',
    }, {
        key: 5,
        label: 'Firma/Bolum',
        id: 'Company',
    },
];
export const Selections = [
    {
        key: 1,
        label: 'Arac',
        placeholder: 'Seciniz',
        id: 'VehicleOwner',
        options: Araclar,
    }, {
        key: 2,
        label: 'Trafik',
        placeholder: 'Seciniz',
        id: 'Traffic',
        options: Trafik,
    }, {
        key: 3,
        label: 'Yol Durumu',
        placeholder: 'Seciniz',
        id: 'RoadType',
        options: YolDurumu,
    }, {
        key: 4,
        label: 'Surus Sartlari',
        placeholder: 'Seciniz',
        id: 'DriveCondition',
        options: SurusSartlari,
    }, {
        key: 5,
        label: 'Hava',
        placeholder: 'Seciniz',
        id: 'Weather',
        options: Hava,
    },
];
export const offRoadSelections = [
    {
        degerlendirme: 'Off-Road Arac Hakkinda Bilgisi',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Dik Inis',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Dik Cikis',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Basarisiz cikis - Geri inis',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Yan Egimden Gecis',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Su Gecisi',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Camur Gecisi',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'V Cukuru ve Diagonal Gecis',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Sanziman Kullanimi Vites Degistirme',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Direksiyon Kullanma Pozisyonu',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Hiz',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Takip Mesafesi',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Ayna Kullanimi',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Arac Ekipman Kullanimi',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Genel Tavir',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
];
export const AntiSkidSelections = [
    {
        degerlendirme: 'Arac Hakkinda Bilgi ve Gunluk Kontroller',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Arac Hakimiyeti (Gaz, debriyaj, fren kullanimi)',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Sanziman Kullanimi ve Vites Degistirme',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Direksiyon Kullanma Pozisyonu',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Sollama ve Serit Degistirme',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Genel Yol Pozisyonu ve Defansif Yaklasim',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Hiz Limitlerine Uyum',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Takip Mesafesi',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Trafik ve Yol isaretleri Bilgisi ve Takibi',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Kontrolsuz Kavsaklar',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Ayna Kontrolu',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Genel Tehlike Kontrolu',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Serit Degistirme ve Donusler',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Oncelik Kurallarina Bakis',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Donel Kavsak Donusleri',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Tehlikeli Alandan Kacinma',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Geri Manevralar',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Fren ve Engel Kacma Manevrasi',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Islak Kuru - Farkli Zeminde Fren ve Hakimiyeti',
        options: durum,
        duzelt: durum,
        devam: durum,
    },
    {
        degerlendirme: 'Islak Zeminde Hakimiyet',
        options: durum,
        duzelt: durum,
        devam: durum,
    },

];
export const DSTSelections = [
    {
        degerlendirme: 'Arac Hakkinda Bilgi ve Gunluk Kontroller',
        options: durum,
        duzelt: duzeltDSTAv[0][1],
        devam: devamDSTAv[0][1],
    },
    {
        degerlendirme: 'Arac Hakimiyeti (Gaz, debriyaj, fren kullanimi)',
        options: durum,
        duzelt: duzeltDSTAv[0][2],
        devam: devamDSTAv[0][2],
    },
    {
        degerlendirme: 'Sanziman Kullanimi ve Vites Degistirme',
        options: durum,
        duzelt: duzeltDSTAv[0][3],
        devam: devamDSTAv[0][3],
    },
    {
        degerlendirme: 'Direksiyon Kullanma Pozisyonu',
        options: durum,
        duzelt: duzeltDSTAv[0][4],
        devam: devamDSTAv[0][4],
    },
    {
        degerlendirme: 'Sollama ve Serit Degistirme',
        options: durum,
        duzelt: duzeltDSTAv[0][5],
        devam: devamDSTAv[0][5],
    },
    {
        degerlendirme: 'Genel Yol Pozisyonu ve Defansif Yaklasim',
        options: durum,
        duzelt: duzeltDSTAv[0][6],
        devam: devamDSTAv[0][6],
    },
    {
        degerlendirme: 'Serit Disiplini',
        options: durum,
        duzelt: duzeltDSTAv[0][7],
        devam: devamDSTAv[0][7],
    },
    {
        degerlendirme: 'Genel Tehlike Gözlemi (3. Şahıslar)',
        options: durum,
        duzelt: duzeltDSTAv[0][8],
        devam: devamDSTAv[0][8],
    },
    {
        degerlendirme: 'Takip Mesafesi (Hareket halinde ve beklerken)',
        options: durum,
        duzelt: duzeltDSTAv[0][9],
        devam: devamDSTAv[0][9],
    },
    {
        degerlendirme: 'Şerit Değ. ve Dönüşlerde Sinyal Kullanımı',
        options: durum,
        duzelt: duzeltDSTAv[0][10],
        devam: devamDSTAv[0][10],
    },
    {
        degerlendirme: 'Ayna Kontrolü (5-8 sn)(Sag sol ve orta)(Kor nokta)',
        options: durum,
        duzelt: duzeltDSTAv[0][11],
        devam: devamDSTAv[0][11],
    },
    {
        degerlendirme: 'Trafik ve Yol Isaretleri Bilgisi ve Takibi',
        options: durum,
        duzelt: duzeltDSTAv[0][12],
        devam: devamDSTAv[0][12],
    },
    {
        degerlendirme: 'Konsantrasyon',
        options: durum,
        duzelt: duzeltDSTAv[0][13],
        devam: devamDSTAv[0][13],
    },
    {
        degerlendirme: 'Oncelik Kurallarina Bakis',
        options: durum,
        duzelt: duzeltDSTAv[0][14],
        devam: devamDSTAv[0][14],
    },
    {
        degerlendirme: 'Donel Kavsak Donusleri',
        options: durum,
        duzelt: duzeltDSTAv[0][15],
        devam: devamDSTAv[0][15],
    },
    {
        degerlendirme: 'Kontrolsuz Kavsaklar',
        options: durum,
        duzelt: duzeltDSTAv[0][16],
        devam: devamDSTAv[0][16],
    },
    {
        degerlendirme: 'Geri Manevralar',
        options: durum,
        duzelt: duzeltDSTAv[0][17],
        devam: devamDSTAv[0][17],
    },
    {
        degerlendirme: 'Hiz Limitlerine / Trafik isaretlerine Uyum',
        options: durum,
        duzelt: duzeltDSTAv[0][18],
        devam: devamDSTAv[0][18],
    },
    {
        degerlendirme: 'Tehlikeli Alanlardan Kacinma',
        options: durum,
        duzelt: duzeltDSTAv[0][19],
        devam: devamDSTAv[0][19],
    },
    {
        degerlendirme: 'Yaya/Bisiklet/Motosiklet Kullanicilarinin Kontrolu',
        options: durum,
        duzelt: duzeltDSTAv[0][20],
        devam: devamDSTAv[0][20],
    },

];


// WEBPACK FOOTER //
// ./src/constants/EgitimConstants.jsx